export default class TmonPlayBanner {
  constructor() {
    this.init();
  }

  init() {
    // 해당딜이 라이브 중인지 아닌지 여부 값
    if (!TMON.htStaticData.isAvLiveVideoModule) return;

    this.dealNo = TMON.htStaticData.htDealInfo.dealNo;
    this.maxItemNum = 4;
    this.nIntervalTimer = 0;
    this.nStopTimer = 0;
    this.nToggleFlagTimer = 0;
    this.nCurrentTimer = 0;

    this.cacheElement();
    this.getLiveInfo();
  }

  cacheElement() {
    this.welWin = $(window);
    this.welBanner = $("#_tmonPlayBanner");
    this.welMsgBox = $("#_tmonPlayBannerMsgBox");
    this.welStateFlag = $("#_tmonPlayBannerFlag");
    this.welVideoThumbImage = this.welBanner.find("img");
    this.welLivePlayerContainer = $("#livePlayerContainer");
  }

  getLiveInfo() {
    try {
      $.ajax({
        type: "GET",
        url: `/api/detail/direct/v1/mediaapi/api/live/deals/${this.dealNo}`,
        success: ({ data }) => {
          if (!data || data.length < 1) {
            return;
          }

          const [htData] = data;
          // 레이어가 노출되지 않는 환경일 경우 DOM을 제거해준다
          if (!htData || htData.livePlanInfo.livePlanLabel !== "LIVE") {
            this.welBanner.hide();
            this.welBanner.remove();
            return;
          }

          this.getLiveThumbImage(htData);
        },
      });
    } catch (error) {
      TMON.oApp.errorHandler({ error: e });
    }
  }

  getLiveThumbImage(liveInfo) {
    try {
      $.ajax({
        type: "GET",
        url: `/api/detail/direct/v1/mediaapi/api/live/${
          liveInfo.mediaNo
        }/player/thumbImage`,
        success: (res) => {
          if (!res || !res.data) {
            return;
          }

          const htData = {
            ...liveInfo,
            verticalThumbImageUrl: res.data.verticalThumbImageUrl,
          };

          this.setEvent();
          this.setData(htData);
        },
      });
    } catch (error) {
      TMON.oApp.errorHandler({ error: e });
    }
  }

  setEvent() {
    // 스크롤시 바운스 애니메이션을 정지한다
    this.welWin.scroll($.proxy(this.stopMsgAnimation, this));
    this.welBanner.on(
      "click",
      $.proxy(this.debounceLeading(this.onClickBanner, 800), this)
    );

    // 페이지 이탈 시 eventListener 등록
    this.welWin.on("beforeunload", () => {
      $.proxy(clearTimeout(this.nIntervalTimer), this);
      $.proxy(clearTimeout(this.nStopTimer), this);
      $.proxy(clearTimeout(this.nCurrentTimer), this);
      $.proxy(clearInterval(this.nToggleFlagTimer), this);
    });
  }

  onClickBanner() {
    document.activeElement.blur(); // 배너 a 태그에 포커스가 있는 경우 엔터를 누르면 플레이어가 중복으로 열리지 않도록 포커스 해제
    this.showLivePlayer();
  }

  showLivePlayer() {
    const firstElement = this.welLivePlayerContainer.children().first();
    this.welLivePlayerContainer
      .children()
      .not(firstElement)
      .remove();

    if (
      window.mediaPlayer &&
      this.welLivePlayerContainer.children().length === 0
    ) {
      window.mediaPlayer.initialize("#livePlayerContainer", this.dealNo);
      this.welLivePlayerContainer.show();
    }
  }

  setData(htData) {
    this.setBannerLayerShow();
    this.setEndDate(htData.liveTimeInfo.endDt);
    this.setRemainderTime();
    this.toggleLiveFlag();
    this.welMsgBox
      .find(".message__item--description")
      .text(htData.captionInfo.desc);

    if (htData.verticalThumbImageUrl) {
      this.welVideoThumbImage.show();
      this.welVideoThumbImage.attr("src", htData.verticalThumbImageUrl);
    } else {
      this.welVideoThumbImage.hide();
    }
  }

  setBannerLayerShow() {
    this.welBanner.show();
    this.welBanner.animate(
      {
        bottom: 23,
      },
      $.proxy(() => {
        this.welMsgBox.delay(800).animate(
          { opacity: "1" },
          500,
          $.proxy(() => {
            this.startMsgAnimation();
          }, this)
        );
      }, this)
    );
  }

  startMsgAnimation() {
    if (this.nIntervalTimer) {
      clearTimeout(this.nIntervalTimer);
      this.nIntervalTimer = 0;
    }

    // 바운스 애니메이션을 2.4초씩 지속, 6초마다 반복한다 (CSS duration 0.4 * 2 * 3 = 2.4s)
    this.nIntervalTimer = setTimeout(
      $.proxy(() => {
        this.welMsgBox.addClass("bounce-animation");

        if (this.nStopTimer) {
          clearTimeout(this.nStopTimer);
          this.nStopTimer = 0;
        }

        this.nStopTimer = setTimeout(
          $.proxy(() => {
            this.stopMsgAnimation();
          }, this),
          2400
        );
      }, this),
      6000
    );
  }

  stopMsgAnimation() {
    this.welMsgBox.removeClass("bounce-animation");
    this.startMsgAnimation();
  }

  toggleLiveFlag() {
    this.stopToggleLiveFlag();

    // LIVE 딱지와 방송잔여시간을 교차로 보여준다
    this.nToggleFlagTimer = setInterval(() => {
      this.welStateFlag.find(".vod__item--time").toggleClass("hide");
    }, 3000);
  }

  stopToggleLiveFlag() {
    if (this.nToggleFlagTimer) {
      clearInterval(this.nToggleFlagTimer);
      this.nToggleFlagTimer = 0;
    }
  }

  setEndDate(sEndDate) {
    const aEnd = sEndDate
      .replace(/:/g, "-")
      .replace(/ /g, "-")
      .split("-");
    const nEndMonth = Number(aEnd[1]) - 1;
    this.oEndDate = new Date(
      aEnd[0],
      nEndMonth,
      aEnd[2],
      aEnd[3],
      aEnd[4],
      aEnd[5]
    );
  }

  setRemainderTime() {
    // 현재시간과 방송종료 시간으로 방송잔여시간을 계산해준다
    const oCurDt = new Date();
    const nDiff = this.oEndDate.getTime() - oCurDt.getTime();

    // 방송잔여시간이 0이되면 LIVE와 잔여시간 교차애니메이션을 제거한다
    if (nDiff <= 0) {
      this.welStateFlag.find(".vod__item--time").addClass("hide");
      this.stopToggleLiveFlag();
      return;
    }

    const nHour = Math.floor((nDiff % (1000 * 3600 * 24)) / (1000 * 3600));
    const nMin = Math.floor((nDiff % (1000 * 3600)) / (1000 * 60));
    const nSec = Math.floor((nDiff % (1000 * 60)) / 1000);

    // Timer
    if (this.oEndDate.getTime() >= oCurDt.getTime()) {
      this.nCurrentTimer = setTimeout(
        $.proxy(this.setRemainderTime, this),
        1000
      );
    } else if (this.nCurrentTimer) {
      clearTimeout(this.nCurrentTimer);
      this.nCurrentTimer = 0;
    }

    this.welStateFlag
      .find(".vod__item--time")
      .html(
        `${this.makeTwoDigit(nHour)}:${this.makeTwoDigit(
          nMin
        )}:${this.makeTwoDigit(nSec)}`
      );
  }

  makeTwoDigit(nTime) {
    // 방송종료 시간을 00:00:00 형태로 변경해준다
    return nTime <= 9 ? `0${nTime}` : nTime;
  }

  // 중복 클릭 방지
  debounceLeading(callback, timeTick) {
    let timer = null;

    return (...args) => {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        callback.apply(this, args);
      }, timeTick);
    };
  }
}
